/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedPoloList200,
  GetApiV1CourseregistrationSharedPoloList401,
  GetApiV1CourseregistrationSharedPoloList500,
  GetApiV1CourseregistrationSharedPoloListQueryParams,
  GetApiV1CourseregistrationSharedPoloListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedPoloList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1CourseregistrationSharedPoloListQueryParamsSchema =
  z.object({
    main: z.boolean().default(false),
  }) as unknown as ToZod<GetApiV1CourseregistrationSharedPoloListQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedPoloList200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1CourseregistrationSharedPoloList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedPoloList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedPoloList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedPoloList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedPoloList500>;

export const getApiV1CourseregistrationSharedPoloListQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedPoloList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedPoloListQueryResponse>;
